export default __webpack_public_path__ + "fc91b156cc933a4178e909bbbe5dc4d2.glb";